import { DefaultTheme } from 'styled-components';
import { getSpacingToken } from '@optimus-web/core';
import { HEIGHT_ACTION_HEADER, HEIGHT_APP_NAV_BAR } from '../../components';

export const ADD_SELL_LIMIT_DIALOG_NAME = 'addSellLimitDialog';
export const DELETE_SELL_LIMIT_DIALOG_NAME = 'deleteSellLimitDialog';

const getHeaderPadding = (theme: DefaultTheme) => 2 * getSpacingToken('200')({ theme });
const getSectionPadding = (theme: DefaultTheme) => 2 * getSpacingToken('300')({ theme });
const headerTitleHeight = 33;

export const getSellLimitsMatrixMaxHeight = (theme: DefaultTheme) => `calc(
    100vh -
    ${HEIGHT_APP_NAV_BAR} -
    ${HEIGHT_ACTION_HEADER} -
    ${getHeaderPadding(theme)}px -
    ${headerTitleHeight}px -
    ${getSectionPadding(theme)}px)
`;
